import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useRegistrations() {
  const createRegistrationCompany = async ({ company }) => {
    const _body = compress(JSON.stringify({ company }));
    const result = await axios.post(
      `${apiUri}/api/v1/registrations/company`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return result.data?.data;
  };

  const confirmRegistration = async (id) => {
    const result = await axios.post(
      `${apiUri}/api/v1/registrations/${id}/company/confirm`
    );
    return result.data?.data;
  };

  return {
    createRegistrationCompany,
    confirmRegistration,
  };
}
